import { Stack } from "@mui/material"
import { ReactElement } from "react"

import AmendEvdcDeviceProgressStepper from "./components/amendEvdcDeviceProgressStepper"
import CoreEvdcDeviceDetails from "./formPages/coreEvdcDeviceDetails"
import ReviewAndSubmitEvdcDevice from "./formPages/reviewAndSubmitEvdcDevice"
import { AmendEVDCDeviceContext } from "./providers/baseProviders/amendEVDCDeviceProvider"
import { Datasets } from "../../../../constants/enums"
import { GRID_SPACING } from "../../../../themes/defaultThemeParams"
import MultiPageForm from "../../../multiPageForm/multiPageForm"
import { AppCard, AppCardContent } from "../../../surfaces/appCard"
import LctDeviceAttachments from "../../common/components/attachments/lctDeviceAttachments"
import { EVDCDeviceFormData } from "../types/providerTypes"

/** The form for amending an EVDC device */
const AmendEVDCDeviceForm = (): ReactElement => (
    <Stack spacing={GRID_SPACING}>
        <AppCard>
            <AppCardContent>
                <AmendEvdcDeviceProgressStepper />
            </AppCardContent>
        </AppCard>

        <MultiPageForm context={AmendEVDCDeviceContext}>
            <CoreEvdcDeviceDetails context={AmendEVDCDeviceContext} />
            <LctDeviceAttachments<EVDCDeviceFormData>
                context={AmendEVDCDeviceContext}
                dataset={Datasets.EVDC}
                isAmendment
            />
            <ReviewAndSubmitEvdcDevice
                context={AmendEVDCDeviceContext}
                isAmendment
            />
        </MultiPageForm>
    </Stack>
)

export default AmendEVDCDeviceForm
